/* eslint-disable arrow-body-style */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from '@services/connection-service';
import { BroadcastService } from '@services/broadcast-service';
import { LocalStorageService } from '@services/local-storage-service';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from '../../../app.config';
import { AppWebBridgeService } from '@services/app-web-bridge-service';

const DOCUMENTS_MODE = 'documents';

@Component({
  selector: 'app-checkup-list',
  templateUrl: './checkup-list.component.html',
  styles: [':host {@apply tw-block tw-h-full; }'],
  standalone: false,
})
export class CheckupListComponent implements OnInit {
  months: any[];
  ui: any = {};
  user: any;
  instantCheckups: Array<any> = [];
  loading: boolean = false;
  isDocumentsMode: boolean = false;

  constructor(
    private readonly conn: ConnectionService,
    private readonly router: Router,
    private readonly appConfig: AppConfig,
    private readonly appWebBridgeService: AppWebBridgeService,
    private readonly broadcast: BroadcastService,
    private readonly event: EventLoggerService,
    private readonly route: ActivatedRoute,
    private readonly localStorageService: LocalStorageService,
  ) {
  }

  async ngOnInit(): Promise<any> {
    this.appWebBridgeService.setStatusBarColor('black');
    this.user = this.conn.getActingUser();
    this.isDocumentsMode = this.route.snapshot.queryParams.mode === DOCUMENTS_MODE;

    this.event.trackEvent('previous_instant_checkup_opened', { username: this.user?.get('username') });
    this.months = this.appConfig.Shared.Months;
    this.loading = true;

    let type: string[];
    if (this.isDocumentsMode) {
      type = [this.appConfig.Shared.InstantCheckup.Type.REPORT, this.appConfig.Shared.InstantCheckup.Type.DOCUMENT];
    } else if (this.route.snapshot.queryParams.username) {
      type = this.appConfig.Shared.InstantCheckup.Type;
    } else {
      type = Object.keys(this.appConfig.Shared.InstantCheckup.Type).filter((type_: string): boolean => {
        return ![this.appConfig.Shared.InstantCheckup.Type.INVALID,
          this.appConfig.Shared.InstantCheckup.Type.REPORT,
          this.appConfig.Shared.InstantCheckup.Type.OTHER,
          this.appConfig.Shared.InstantCheckup.Type.DOCUMENT].includes(type_);
      });
    }

    this.instantCheckups = await this.conn.fetchInstantCheckup({
      userId: this.user?.get('username'),
      project: ['type', 'imagePath'],
      type,
    });
    this.loading = false;
  }

  showError(message: any): void {
    this.broadcast.broadcast('NOTIFY', { message });
  }

  menuAction(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }

  routeTo(id: any, type: string): void {
    this.localStorageService?.setValue('checkupListExpectedFacePhoto', type);
    const queryParams: any = { fromList: true };
    if (this.isDocumentsMode) queryParams.mode = DOCUMENTS_MODE;
    this.router.navigate([`/user/instantCheckup/${id}`], { queryParams });
  }
}
